import React from "react";

const NotificationsModal = (props) => {

    const {
        getListNotifications
    } = props;

    const getLastElementsListNotifications = getListNotifications.slice(-3)

    return (
        <div className="notification-modal">
            <div className="notification-modal-header">
                <h3 className="notification-modal-header__label">Notifications</h3>
            </div>
            <div className="notification-modal-list">
                {getLastElementsListNotifications.map((el, i) => {
                    return (
                        <div key={i} className="notification-modal-list__item">
                            <p className="notification-modal-list__item-message">{el?.message}</p>
                            <p className="notification-modal-list__item-date">{el?.date}</p>
                        </div>
                    )
                } )}
            </div>
        </div>
    )
}
export default NotificationsModal;